import React from 'react';
import { Box, Typography, IconButton, Divider, CircularProgress } from '@mui/material';
import * as fieldListStyle from '../../fields/fieldtab/FieldListStyle';
import { injectIntl } from 'react-intl';
import { createSvgIcon } from '@mui/material/utils';

const BottomSheet = ({ intl, data, selectedCount, onClose, onDelete, onExport, selectedItems, isExporting }) => {
  const selectedCountLength = selectedCount;

  let activityText = '';
  if (selectedCount === 1) {
    const selectedTask = data.find(task => task.id === selectedItems[0]);
    activityText = selectedTask?.activityName || '';
  } else if (selectedCount > 1) {
    activityText = `${selectedCountLength} er valgt`;
  }

  const CloseIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path d="M19.5 6.91L18.09 5.5L12.5 11.09L6.91 5.5L5.5 6.91L11.09 12.5L5.5 18.09L6.91 19.5L12.5 13.91L18.09 19.5L19.5 18.09L13.91 12.5L19.5 6.91Z" fill="#3F4949" />
    </svg>,
    'CloseIcon'
  );

  const DeleteFieldIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 3.5V4.5H20.5V6.5H19.5V19.5C19.5 20.6 18.6 21.5 17.5 21.5H7.5C6.4 21.5 5.5 20.6 5.5 19.5V6.5H4.5V4.5H9.5V3.5H15.5ZM7.5 19.5H17.5V6.5H7.5V19.5ZM9.5 8.5H11.5V17.5H9.5V8.5ZM15.5 8.5H13.5V17.5H15.5V8.5Z" fill="#BA1A1A" />
    </svg>,
    'DeleteFieldIcon'
  );

  const ExportIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M12 16.501L7 11.501L8.4 10.051L11 12.651V4.50098H13V12.651L15.6 10.051L17 11.501L12 16.501ZM6 20.501C5.45 20.501 4.97917 20.3051 4.5875 19.9135C4.19583 19.5218 4 19.051 4 18.501V15.501H6V18.501H18V15.501H20V18.501C20 19.051 19.8042 19.5218 19.4125 19.9135C19.0208 20.3051 18.55 20.501 18 20.501H6Z" fill="#3F4949" />
    </svg>,
    'ExportIcon'
  );


  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        background: '#F2F4F4',
        boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.15)',
        zIndex: 1000,
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        display: selectedCount > 0 ? 'flex' : 'none',
        flexDirection: 'column',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {/* Drag Handle */}
      <Box sx={{ textAlign: 'center', padding: '10px 0' }}>
        <Box sx={{ width: 40, height: 4, backgroundColor: '#7A757F', borderRadius: 2, margin: '0 auto' }} />
      </Box>

      {/* Header */}
      <Box sx={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={onClose} sx={{ marginRight: '8px' }}>
          <CloseIcon />
        </IconButton>
        <Typography
          sx={{
            flexGrow: 1,
            textAlign: 'flex-start',
            color: '#191C1C',
            fontSize: 22,
            fontFamily: 'Inter',
            fontWeight: '400',
          }}
        >
          {activityText}
        </Typography>
        <Box sx={{ width: 'auto' }} />
      </Box>

      {/* Content Section */}
      <Box sx={{ padding: '0px 16px' }}>
        {/* Divider with padding above and below */}
        <Box sx={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <Divider />
        </Box>

        <Box
          onClick={selectedCount > 0 ? onExport : undefined}
          sx={{
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '16px'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              onClick={onExport}
              disabled={selectedCount === 0 || isExporting}
              sx={{
                position: 'relative',
                height: '40px',
                padding: '0px',
                '& .MuiSvgIcon-root': {
                  padding: '0px',
                  margin: '0px',
                },
                '& > *:first-of-type': {
                  padding: '0px',
                  margin: '0px',
                },
              }}
            >
              {/*{isExporting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <ExportIcon />
              )}*/}
              <ExportIcon />
            </IconButton>
            <Typography style={{ ...fieldListStyle.listRowItem, marginLeft: '12px' }}>
              {intl.formatMessage({ id: 'REPORTS_EXPORT' })}
            </Typography>
          </Box>
        </Box>

        {/* Entire clickable delete area */}
        <Box
          onClick={selectedCount > 0 ? onDelete : undefined}
          sx={{
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '80px'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DeleteFieldIcon alt="Delete" />
            <Typography style={{ ...fieldListStyle.fieldDeleteTextStyle, marginLeft: '12px' }}>
              {intl.formatMessage({ id: 'DELETE_TASK' })}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default injectIntl(BottomSheet);
